import React, { useState, forwardRef, useImperativeHandle, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { FormControl, InputLabel, Select, MenuItem, TextField, Checkbox, FormControlLabel } from '@material-ui/core';
import { toast } from 'react-toastify';
import _ from 'lodash';
import OverLoading from '../global/OverLoading';
import Constants from '../../common/constants';
import { getStaffById, updateStaff, updateCredential, updatePermission } from '../../actions/admin/staffAction';
import { toggleModal } from '../../actions/modal';

const FormUpdate = forwardRef(({ getStaffById, updateStaff, updateCredential, updatePermission, staffId, toggleModal, updateList }, ref) => {
  const submitButtonRef = useRef();
  useImperativeHandle(ref, () => ({
    submitForm() {
      submitButtonRef.current.click();
    },
  }));

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    id:          '',
    email:       '',
    position:    '',
    password:    '',
    permissions: {},
  });

  const { email, position, password, permissions } = formData;

  const fetchStaffToUpdate = async () => {
    try {
      const initPerm = {};
      Constants.PermissionsInit.map((perm) => {
        _.assign(initPerm, { [perm]: false });
      });

      setLoading(true);
      const data = await getStaffById(staffId);
      const formattedPermissions = {};

      if (data) {
        const extPerm = data.permissions;
        if (extPerm) {
          _.forEach(initPerm, (value, key) => {
            const findKey = _.some([extPerm], key);
            if (findKey) {
              _.assign(formattedPermissions, { [key]: extPerm[key] });
            } else {
              _.assign(formattedPermissions, { [key]: value });
            }
          });

          setFormData({
            id:          data.id,
            email:       data.email,
            position:    data.position,
            permissions: formattedPermissions,
          });
        }

        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      toast.error('An unexpected error has occurred');
    }
  };

  useEffect(() => {
    fetchStaffToUpdate();
  }, []);

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const updateCurrentPermission = (e) => {
    setFormData({ ...formData, permissions: { ...formData.permissions, [e.target.name]: !formData.permissions[e.target.name] } });
  };

  const onSubmitStaff = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = {
        id:       formData.id,
        email:    formData.email,
        position: formData.position,
      };

      await updateStaff(formData.id, data).then((response) => {
        if (response.status === 200) {
          toggleModal();
          toast.success('Staff Info has been updated.');

          // callback
          updateList();
        } else {
          setLoading(false);
          toast.error('An unexpected error has occurred');
        }
      });
    } catch (err) {
      toast.error(err);
      setLoading(false);
    }
  };

  const onSubmitCredential = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await updateCredential(formData.id, formData.password).then((response) => {
        if (response.status === 200) {
          toggleModal();
          toast.success('Password has been updated.');

          // callback
          updateList();
        } else {
          setLoading(false);
          toast.error('An unexpected error has occurred');
        }
      });
    } catch (err) {
      toast.error(err);
      setLoading(false);
    }
  };

  const onSubmitPermission = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await updatePermission(formData.id, formData.permissions).then((response) => {
        if (response.status === 200) {
          toggleModal();
          toast.success('Permission has been updated.');

          // callback
          updateList();
        } else {
          setLoading(false);
          toast.error('An unexpected error has occurred');
        }
      });
    } catch (err) {
      toast.error(err);
      setLoading(false);
    }
  };

  const findHyphen = (str) => {
    const regexp = /[\d -]+/g;
    return !!regexp.test(str);
  };

  return (
    <div className="px-3">
      {loading && <OverLoading />}
      <div className="alert alert-info show mb-4" role="alert">
        In order for the updates to take effect, user needs to sign-out and login again.
      </div>

      <form
        className="form position-relative"
        autoComplete="off"
      >
        <div className="mb-2">
          <h4>STAFF INFO</h4>

          <FormControl style={{ width: '100%', marginBottom: 10 }}>
            <TextField type="email" id="email" label="Email" name="email" value={email} onChange={(e) => onChange(e)} />
          </FormControl>

          <FormControl style={{ width: '100%' }}>
            <InputLabel id="position-label">Position</InputLabel>
            <Select
              labelId="position-label"
              id="position"
              name="position"
              value={position}
              onChange={(e) => onChange(e)}
            >
              <MenuItem value={Constants.StaffPosition.Contractor}>{ Constants.StaffPosition.Contractor }</MenuItem>
              <MenuItem value={Constants.StaffPosition.Associate}>{ Constants.StaffPosition.Associate }</MenuItem>
              <MenuItem value={Constants.StaffPosition.Manager}>{ Constants.StaffPosition.Manager }</MenuItem>
              <MenuItem value={Constants.StaffPosition.Super}>{ Constants.StaffPosition.Super }</MenuItem>
              <MenuItem value={Constants.StaffPosition.Developer}>{ Constants.StaffPosition.Developer }</MenuItem>
              <MenuItem value={Constants.StaffPosition.Scrapper}>{ Constants.StaffPosition.Scrapper }</MenuItem>
            </Select>
          </FormControl>
        </div>

        <div className="form-group mb-3 text-right">
          <input
            type="submit"
            className="btn btn-primary d-block"
            value="Update Staff Information"
            onClick={(e) => onSubmitStaff(e)}
            style={{
              width:        '50%',
              margin:       '20px auto',
              padding:      '10px 0',
              borderRadius: 4,
            }}
          />
        </div>
      </form>

      <form
        className="form position-relative"
        autoComplete="off"
      >
        <div className="mt-5 mb-2">
          <h4>PASSWORD</h4>
          <FormControl style={{ width: '100%' }}>
            <TextField id="password" label="Set Password" name="password" value={password} onChange={(e) => onChange(e)} />
          </FormControl>
        </div>

        <div className="form-group mb-3 text-right">
          <input
            type="submit"
            className="btn btn-primary d-block"
            value="Update Password"
            onClick={(e) => onSubmitCredential(e)}
            style={{
              width:        '50%',
              margin:       '20px auto',
              padding:      '10px 0',
              borderRadius: 4,
            }}
          />
        </div>
      </form>

      <form
        className="form position-relative"
        autoComplete="off"
      >
        <div className="mt-5 mb-2">
          <h4>PERMISSIONS</h4>
          <FormControl style={{ display: 'block', width: '100%' }}>
            {
              _.map(permissions, (value, key) => {
                if (key !== 'staff_id') {
                  if (findHyphen(key)) {
                    return (
                      <p style={{
                        display:     'inline-block',
                        width:       220,
                        paddingLeft: 5,
                      }}
                      >
                        --
                      </p>
                    );
                  } else {
                    return (
                      <FormControlLabel
                        key={key}
                        style={{ display: 'inline-block', width: 215 }}
                        control={<Checkbox name={key} checked={value} onChange={(e) => updateCurrentPermission(e)} />}
                        label={key}
                      />
                    );
                  }
                }
              })
            }
          </FormControl>
        </div>

        <div className="form-group mb-3 text-right">
          <input
            type="submit"
            className="btn btn-primary d-block"
            value="Update Permissions"
            onClick={(e) => onSubmitPermission(e)}
            style={{
              width:        '50%',
              margin:       '20px auto',
              padding:      '10px 0',
              borderRadius: 4,
            }}
          />
        </div>
      </form>
    </div>
  );
});

export default connect(null, { getStaffById, updateStaff, updateCredential, updatePermission, toggleModal }, null, {
  forwardRef: true,
})(FormUpdate);
